import React from "react";
import { IoIosArrowForward } from "react-icons/io";
import { useSelector, useDispatch } from "react-redux";
import { setElement } from "../../Redux/SidebarReducer";
import { Link, useLocation } from "react-router-dom";
import { RiAdvertisementFill } from "react-icons/ri";
import { GoPin } from "react-icons/go";
import { PiFlagBanner } from "react-icons/pi";
import { MdVerticalAlignTop } from "react-icons/md";
import { IoTicketOutline } from "react-icons/io5";

const AdvertisingSidbar = (props) => {
  const { title, show, icon: IconComponent } = props;
  const location = useLocation();
  const elementActive = useSelector((state) => state.Sidebar.elementActive);
  const dispatch = useDispatch();
  const handleClick = () => {
    const value = title === elementActive ? "" : title;
    dispatch(setElement(value));
  };

  const AdvertisingMenu = [
    {
      link: `/Ads-Pin`,
      name: "Pin",
      icon: GoPin,
    },
    {
      link: `/Ads-Main-Page`,
      name: "Main page",
      icon: PiFlagBanner,
    },

    {
      link: `/Ads-Search-Result`,
      name: "Search Result",
      icon: MdVerticalAlignTop,
    },
    {
      link: `/Ads-Ticket`,
      name: "Ticket",
      icon: IoTicketOutline,
    },
  ];

  return (
    <li className=" ">
      <span
        onClick={handleClick}
        className="pr-0 py-[12px]  pl-[25px]  flex hover:text-primary duration-300 relative  items-center cursor-pointer"
      >
        <RiAdvertisementFill className={"text-[16px] mr-[20px]"} />
        Advertising
        <IoIosArrowForward
          className={`absolute right-3 duration-300 text-[14px]
        ${elementActive === title ? "rotate-90" : "rotate-0"}    `}
        />
      </span>
      <ul

        className={`text-[15px]  pl-[22px] duration-300 overflow-hidden  ${
          elementActive === title ? "h-[11rem]" : "h-0"
        } `}
      >
        {AdvertisingMenu.map((item, idx) => {
          return (
            <Link key={idx} to={item?.link} color="inherit" underline="none">
              <li
                className={`pr-0 py-[8px]  pl-[25px] text-center whitespace-nowrap  flex justify-start gap-x-3 items-center ${item?.link === location.pathname
                    ? "bg-primary text-darkTextColor hover:text-darkTextColor"
                    : "hover:text-primary"
                  }`}
              >
                {item?.icon ? (
                  <item.icon />
                ) : (
                  <svg
                    className="icon-10"
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <g>
                      <circle
                        cx="12"
                        cy="12"
                        r="8"
                        fill="currentColor"
                      ></circle>
                    </g>
                  </svg>
                )}
                <span className=" duration-100 flex  items-center">
                  {item?.name}
                </span>
              </li>
            </Link>
          );
        })}
      </ul>
    </li>
  );
};

export default AdvertisingSidbar;
